import { CmsPage } from '../cms/CmsPage'

/* The home page is no longer a running order written here.
 *
 * It used to be eleven imports in a fragment, and the comment above them
 * explained the sequence: see the cars, understand why us, understand the
 * process, find the monthly number, meet the banks, take the offer, read the
 * reviews. That reasoning has not gone anywhere — it is the order the page
 * ships in, declared in api/src/config/cms.ts — but it is now a decision the
 * showroom can make rather than one that needs a deploy.
 *
 * What draws the page is the layout: which sections, in what order, switched
 * on or off, with whatever copy and design the console has set. The
 * components themselves are unchanged in every other respect. */
function Home() {
  return <CmsPage />
}

export default Home
